export const DEFAULT_SUPPORT_CONTACT = {
    phone: '053 96 11 96 0',
    email: 'support@absat.org',
};

export const DEFAULT_SECTIONS = [
    {
        key: 'support',
        labelAr: 'الصيانة والدعم الفني',
        labelEn: 'Support and Maintenance',
        isActive: true,
        sortOrder: 1,
    },
    {
        key: 'salesAndInvoices',
        labelAr: 'المبيعات والفواتير',
        labelEn: 'Sales And Invoices',
        isActive: true,
        sortOrder: 2,
    },
    {
        key: 'licences',
        labelAr: 'التراخيص',
        labelEn: 'Licences',
        isActive: true,
        sortOrder: 3,
    },
    {
        key: 'complains',
        labelAr: 'الاستفسارات والشكاوي',
        labelEn: 'Complains',
        isActive: true,
        sortOrder: 4,
    },
];

export const DEFAULT_PRODUCTS = [
    {
        key: 'odooServices',
        labelAr: 'خدمات اودو',
        labelEn: 'Odoo Services',
        isActive: true,
        sortOrder: 1,
    },
    {
        key: 'absatBusinessErp',
        labelAr: 'نظام ابسط اعمال ERP',
        labelEn: 'Absat Business ERP',
        isActive: true,
        sortOrder: 2,
    },
    {
        key: 'webDevelopmentServices',
        labelAr: 'خدمات تطوير المواقع الالكترونيه',
        labelEn: 'Web Development Services',
        isActive: true,
        sortOrder: 3,
    },
    {
        key: 'mobileDevelopmentServices',
        labelAr: 'خدمات تطوير الجوال',
        labelEn: 'Mobile Development Services',
        isActive: true,
        sortOrder: 4,
    },
];

export const DEFAULT_STATUSES = [
    {
        _id: 'default-status-new',
        labelAr: 'جديدة',
        labelEn: 'New',
        isDefault: true,
        isActive: true,
        sortOrder: 1,
    },
    {
        _id: 'default-status-review',
        labelAr: 'تحت المراجعة',
        labelEn: 'Review',
        isDefault: false,
        isActive: true,
        sortOrder: 2,
    },
    {
        _id: 'default-status-pending',
        labelAr: 'معلقة',
        labelEn: 'Pending',
        isDefault: false,
        isActive: true,
        sortOrder: 3,
    },
    {
        _id: 'default-status-processing',
        labelAr: 'جاري التنفيذ',
        labelEn: 'Processing',
        isDefault: false,
        isActive: true,
        sortOrder: 4,
    },
    {
        _id: 'default-status-completed',
        labelAr: 'مكتملة',
        labelEn: 'Completed',
        isDefault: false,
        isActive: true,
        sortOrder: 5,
    },
    {
        _id: 'default-status-closed',
        labelAr: 'مغلقة',
        labelEn: 'Closed',
        isDefault: false,
        isActive: true,
        sortOrder: 6,
    },
    {
        _id: 'default-status-canceled',
        labelAr: 'ملغي',
        labelEn: 'Canceled',
        isDefault: false,
        isActive: true,
        sortOrder: 7,
    },
];

export const TICKET_PRIORITIES = [
    { value: 'critical', labelAr: 'حرجة جداً (P1)', labelEn: 'Critical (P1)', color: '#dc2626', bg: '#fee2e2' },
    { value: 'high', labelAr: 'عالية (P2)', labelEn: 'High (P2)', color: '#ea580c', bg: '#ffedd5' },
    { value: 'medium', labelAr: 'متوسطة (P3)', labelEn: 'Medium (P3)', color: '#ca8a04', bg: '#fef3c7' },
    { value: 'low', labelAr: 'منخفضة (P4)', labelEn: 'Low (P4)', color: '#16a34a', bg: '#dcfce7' },
];

export const getPriorityOptions = (lang = 'ar') =>
    TICKET_PRIORITIES.map((item) => ({
        label: lang === 'ar' ? item.labelAr : item.labelEn,
        value: item.value,
        lang,
    }));

export const getPriorityDefinition = (priority) =>
    TICKET_PRIORITIES.find((item) => item.value === String(priority || '').trim().toLowerCase()) ||
    TICKET_PRIORITIES.find((item) => item.value === 'medium');

export const getPriorityLabel = (priority, lang = 'ar') => {
    const item = getPriorityDefinition(priority);
    return lang === 'ar' ? item.labelAr : item.labelEn;
};

export const getPriorityAppearance = (priority) => {
    const item = getPriorityDefinition(priority);
    return { bg: item.bg, color: item.color, dot: item.color };
};

const normalizeCatalogItems = (items, fallbackItems) => {
    const source = Array.isArray(items) ? items : fallbackItems;

    return source
        .map((item, index) => ({
            key: item?.key || item?.value || '',
            labelAr: item?.labelAr || item?.label || item?.key || item?.value || '',
            labelEn: item?.labelEn || item?.label || item?.key || item?.value || '',
            isActive: item?.isActive !== false,
            visibility: String(item?.visibility || '').toLowerCase() === 'internal' ? 'internal' : 'external',
            sortOrder: Number.isFinite(Number(item?.sortOrder)) ? Number(item.sortOrder) : index + 1,
        }))
        .filter((item) => item.key)
        .sort((a, b) => a.sortOrder - b.sortOrder);
};

const STATUS_GROUP_ALIASES = {
    new: 'new',
    'جديدة': 'new',
    review: 'review',
    'تحتالمراجعة': 'review',
    pending: 'pending',
    pendding: 'pending',
    'معلقة': 'pending',
    processing: 'processing',
    prossesing: 'processing',
    'جاريالتنفيذ': 'processing',
    'جارىالتنفيذ': 'processing',
    completed: 'completed',
    completely: 'completed',
    'مكتملة': 'completed',
    closed: 'closed',
    'مغلقة': 'closed',
    canceled: 'canceled',
    cancelled: 'canceled',
    'ملغي': 'canceled',
    'ملغية': 'canceled',
};

const normalizeStatusItems = (items, fallbackItems = DEFAULT_STATUSES) => {
    const source = Array.isArray(items) && items.length > 0 ? items : fallbackItems;
    const normalized = source
        .map((item, index) => ({
            _id: String(item?._id || item?.id || item?.value || `status-${index + 1}`),
            labelAr: item?.labelAr || item?.label || item?.key || item?.value || '',
            labelEn: item?.labelEn || item?.label || item?.key || item?.value || '',
            color: item?.color || '',
            isDefault: item?.isDefault === true,
            isActive: item?.isActive !== false,
            sortOrder: Number.isFinite(Number(item?.sortOrder)) ? Number(item.sortOrder) : index + 1,
        }))
        .filter((item) => item.labelAr && item.labelEn)
        .sort((a, b) => a.sortOrder - b.sortOrder);

    const defaultStatus =
        normalized.find((item) => item.isDefault && item.isActive !== false) ||
        normalized.find((item) => item.isDefault) ||
        normalized.find((item) => item.isActive !== false) ||
        normalized[0];

    return normalized.map((item) => ({
        ...item,
        isDefault: Boolean(defaultStatus && String(item._id) === String(defaultStatus._id)),
    }));
};

export const normalizeSupportSettings = (payload) => {
    const data = payload?.data || payload || {};

    return {
        contact: {
            phone: data?.contact?.phone || DEFAULT_SUPPORT_CONTACT.phone,
            email: data?.contact?.email || DEFAULT_SUPPORT_CONTACT.email,
        },
        sections: normalizeCatalogItems(data?.sections, DEFAULT_SECTIONS),
        products: normalizeCatalogItems(data?.products, DEFAULT_PRODUCTS),
        statuses: normalizeStatusItems(data?.statuses, DEFAULT_STATUSES),
    };
};

export const getLocalizedOptions = (items, lang = 'ar', includeInactive = false) =>
    normalizeCatalogItems(items, [])
        .filter((item) => includeInactive || item.isActive !== false)
        .filter((item) => item.visibility !== 'internal')
        .filter((item) => String(item.key || '').trim().length >= 2)
        .map((item) => ({
            label: lang === 'ar' ? item.labelAr : item.labelEn,
            value: item.key,
            lang,
        }));

export const getCatalogLabel = (items, value, lang = 'ar') => {
    const match = normalizeCatalogItems(items, []).find((item) => item.key === value);
    if (!match) return value;
    return lang === 'ar' ? match.labelAr : match.labelEn;
};

export const getAllowedProducts = (items, allowedProductIds = [], options = {}) => {
    const normalizedItems = normalizeCatalogItems(items, DEFAULT_PRODUCTS)
        .filter((item) => item.isActive !== false)
        .filter((item) => item.visibility !== 'internal');
    const allowedIds = Array.isArray(allowedProductIds) ? allowedProductIds.filter(Boolean) : [];
    const fallbackToAll = options?.fallbackToAll === true;

    if (allowedIds.length === 0) {
        return fallbackToAll ? normalizedItems : [];
    }

    return normalizedItems.filter((item) => allowedIds.includes(item.key));
};

export const normalizeStatusValue = (status) => {
    return String(status || '').trim();
};

export const getLocalizedStatusOptions = (items, lang = 'ar', includeInactive = false) =>
    normalizeStatusItems(items, DEFAULT_STATUSES)
        .filter((item) => includeInactive || item.isActive !== false)
        .map((item) => ({
            label: lang === 'ar' ? item.labelAr : item.labelEn,
            value: item._id,
            lang,
        }));

const normalizeStatusGroupToken = (value) =>
    STATUS_GROUP_ALIASES[String(value || '').trim().toLowerCase().replace(/\s+/g, '').replace(/-/g, '')] ||
    String(value || '').trim().toLowerCase().replace(/\s+/g, '').replace(/-/g, '');

export const getStatusDefinition = (items, status) => {
    const raw = normalizeStatusValue(status);
    const normalizedItems = normalizeStatusItems(items, DEFAULT_STATUSES);
    if (!raw) {
        return normalizedItems.find((item) => item.isDefault) || normalizedItems[0] || null;
    }
    const byId = normalizedItems.find((item) => String(item._id) === raw);
    if (byId) return byId;
    const normalizedLegacy = normalizeStatusGroupToken(raw);
    return normalizedItems.find((item) =>
        normalizeStatusGroupToken(item.labelEn) === normalizedLegacy ||
        normalizeStatusGroupToken(item.labelAr) === normalizedLegacy
    ) || null;
};

export const getStatusCategory = (items, status) =>
    normalizeStatusGroupToken(getStatusDefinition(items, status)?.labelEn || getStatusDefinition(items, status)?.labelAr || status || 'closed');

export const getDefaultStatusId = (items) =>
    normalizeStatusItems(items, DEFAULT_STATUSES).find((item) => item.isDefault)?._id || '';

export const getStatusId = (items, status) =>
    getStatusDefinition(items, status)?._id || normalizeStatusValue(status);

export const matchesStatusGroup = (items, status, group) =>
    !group || group === 'all' ? true : getStatusCategory(items, status) === group;

export const getStatusLabel = (items, status, lang = 'ar') => {
    const definition = getStatusDefinition(items, status);
    if (!definition) return status;
    return lang === 'ar' ? definition.labelAr : definition.labelEn;
};

const normalizeHexColor = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    const withHash = raw.startsWith('#') ? raw : `#${raw}`;
    if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(withHash)) return '';
    return withHash.toLowerCase();
};

const hexToRgb = (hex) => {
    const normalized = normalizeHexColor(hex);
    if (!normalized) return null;
    const raw = normalized.replace('#', '');
    const full = raw.length === 3 ? raw.split('').map((c) => c + c).join('') : raw;
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    return Number.isFinite(r) && Number.isFinite(g) && Number.isFinite(b) ? { r, g, b } : null;
};

const buildAppearanceFromHex = (hex) => {
    const rgb = hexToRgb(hex);
    const normalized = normalizeHexColor(hex);
    if (!rgb || !normalized) return null;
    return {
        bg: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.14)`,
        color: normalized,
        dot: normalized
    };
};

export const getStatusAppearance = (items, status) => {
    const definition = getStatusDefinition(items, status);
    const custom = buildAppearanceFromHex(definition?.color);
    if (custom) return custom;
    const normalizedStatus = getStatusCategory(items, status);

    switch (normalizedStatus) {
        case 'new':
            return { bg: '#dbeafe', color: '#1d4ed8', dot: '#2563eb' };
        case 'review':
            return { bg: '#ede9fe', color: '#6d28d9', dot: '#8b5cf6' };
        case 'pending':
            return { bg: '#fef3c7', color: '#b45309', dot: '#f59e0b' };
        case 'processing':
            return { bg: '#dcfce7', color: '#15803d', dot: '#22c55e' };
        case 'completed':
            return { bg: '#ccfbf1', color: '#0f766e', dot: '#14b8a6' };
        case 'canceled':
            return { bg: '#fee2e2', color: '#b91c1c', dot: '#ef4444' };
        case 'closed':
        default:
            return { bg: '#e2e8f0', color: '#475569', dot: '#94a3b8' };
    }
};
export const ALLOW_FIILE_TYPES = [
    "image/png", 
    "image/jpg", 
    "image/jpeg", 
    "image/gif",
    "image/webp",
    "application/pdf", 
    "application/msword", 
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/plain",
    "text/csv",
    "application/zip",
    "application/x-zip-compressed",
    "application/x-rar-compressed",
    "video/mp4"
];
